const PATH = 'fe.components.reliability_test.performance_report_section';

const messages = {
  video: {
    key: `${PATH}.video`,
    defaultValue: 'Video {{number}}'
  },
  videoScore: {
    key: `${PATH}.video_score`,
    defaultValue: 'Video {{number}}, {{score}}%'
  }
};

export default messages;
